import $ from 'jquery';
// @ts-ignore
import router from '../main';
//import Vue from 'vue'
import NotificationsSvc from './NotificationsSvcT';
var AuthService = /** @class */ (function () {
    function AuthService() {
    }
    AuthService.prototype.Init = function () {
        //NotificationsSvcT.Notify("sdfsdfsdffds","sdfdsfdsf")
        this.sessionId = localStorage.getItem("sessionId");
        var userDataStr = localStorage.getItem("userData");
        if (userDataStr) {
            this.userData = JSON.parse(userDataStr);
            if (this.userData.names && this.userData.names.length > 0) {
                this.userName = this.userData.names[0].last_name + ' ' + this.userData.names[0].first_name + ' ' + this.userData.names[0].middle_name;
                //var data = {
                //    index: 0,
                //    name: this.userData.names[0].first_name,
                //    surname: this.userData.names[0].last_name,
                //    lastname: this.userData.names[0].middle_name,
                //    weight: 100
                //};
                //this.authors.push(data);
                //this.iprights.push(data);
            }
            else if (this.userData.identifiers && this.userData.identifiers.length > 0) {
                this.userName = this.userData.identifiers[0].identifier;
            }
            else {
                this.userName = this.userData.id;
            }
        }
    };
    AuthService.prototype.SighOut = function () {
        this.sessionId = localStorage.getItem("sessionId");
        $.ajax({
            url: process.env.VUE_APP_ROOT_API + 'api/signOut?userId=' + this.sessionId,
            dataType: "json",
            success: function (result) {
                var data = result;
                if (data.IsOkay) {
                    localStorage.removeItem("userData");
                    localStorage.removeItem("sessionId");
                    NotificationsSvc.Notify('', 'Вы вышли из учетной записи');
                    router.push('/Login');
                }
            },
            error: function (e) {
                NotificationsSvc.Notify('Error', JSON.stringify(e));
            }
        });
    };
    AuthService.prototype.SighIn = function () {
        console.log(process.env.VUE_APP_ROOT_API);
        this.sessionId = localStorage.getItem("sessionId");
        //var c = () => { return true };
        if (!this.sessionId) {
            this.sessionId = this.NewGuid();
            localStorage.setItem("sessionId", this.sessionId);
            this.startAuth();
        }
        else {
            this.CheckIsloggedAndSignIn();
        }
    };
    AuthService.prototype.CheckIsloggedAndSignIn = function () {
        var that = this;
        if (!this.userData) {
            that.startAuth();
            return;
        }
        var userId = this.userData.id;
        $.ajax({
            url: process.env.VUE_APP_ROOT_API + 'api/isLogged?userId=' + userId,
            dataType: "json",
            crossDomain: true,
            success: function (result) {
                var data = result;
                if (data.IsOkay) {
                    var userDataStr = JSON.stringify(data.PersonData);
                    localStorage.setItem("userData", userDataStr);
                    router.push('/Home');
                    if (this.authWindow) {
                        this.authWindow.close();
                    }
                }
                else {
                    that.startAuth();
                }
            },
            error: function (data) {
                //TODO Show Error Msg
                //var c = data;
                that.startAuth();
            }
        });
    };
    AuthService.prototype.startAuth = function () {
        //this.authWindow = window.open('https://pds.testnet.ipchain.ru/auth/authorize?redirect_uri=' + encodeURIComponent(process.env.VUE_APP_REDIRECT_URI + "") + '&client_id=dsemenov&response_type=code&lang=ru&scope=n_name&state=' + this.sessionId, 'AuthPopup', 'width=500,height=800,centerscreen=1,menubar=0,toolbar=0,location=0,personalbar=0,status=0,titlebar=0,dialog=1');
        //this.authWindow = window.open('https://pds.testnet.ipchain.ru/auth/authorize?client_id=dsemenov&response_type=code&lang=ru&scope=n_name&state=' + this.sessionId, 'AuthPopup', 'width=500,height=800,centerscreen=1,menubar=0,toolbar=0,location=0,personalbar=0,status=0,titlebar=0,dialog=1');
        this.authWindow = window.open(process.env.VUE_APP_PDSURL + 'auth/authorize?client_id=' + process.env.VUE_APP_CLIENTID + '&response_type=code&lang=ru&scope=n_name&state=' + this.sessionId, 'AuthPopup', 'width=500,height=800,centerscreen=1,menubar=0,toolbar=0,location=0,personalbar=0,status=0,titlebar=0,dialog=1');
        if (window.WebSocket === undefined) {
            $("#container").append("Your browser does not support WebSockets");
            return;
        }
        else {
            this.ws = this.initWS();
        }
    };
    AuthService.prototype.initWS = function () {
        var that = this;
        var socketUrl = process.env.VUE_APP_WSS + "";
        var socket = new WebSocket(socketUrl);
        //var socket = new WebSocket("wss://echo.websocket.org");
        //var container = $("#container");
        socket.onopen = function () {
            var toSend = { SessionId: that.sessionId };
            that.ws.send(JSON.stringify(toSend));
        };
        socket.onmessage = function (e) {
            var data = JSON.parse(e.data);
            if (data.IsOkay) {
                //that.authWindow.close();
                localStorage.setItem("userData", JSON.stringify(data.PersonData));
                NotificationsSvc.Notify('', 'Вы успешно авторизовались');
                router.push('/Home');
            }
        };
        socket.onclose = function () {
        };
        return socket;
    };
    AuthService.prototype.NewGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    return AuthService;
}());
var AuthSvc = new AuthService();
export default AuthSvc;
